<h2 mat-dialog-title>Adding message type</h2>
<mat-dialog-content>
  <mat-form-field appearance="fill">
    <mat-label>Enter the message type</mat-label>
    <input
      matInput
      [(ngModel)]="data.name"
      (input)="onInputChange($event)"
      maxlength="30"
      name="messageType"
      #messageType="ngModel"
      required
    />
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onNoClick()">Cancel</button>
  <button
    mat-button
    cdkFocusInitial
    (click)="onAddClick()"
    [disabled]="!data.name || messageType.invalid || data.name.length === 0"
  >
    Add
  </button>
</mat-dialog-actions>

